import React from 'react';

import { datadogRum } from '@datadog/browser-rum';
import {
  IconSquareRoundedCheckFilled,
  IconSquareRoundedPlus,
} from '@tabler/icons-react';

import Constants from '@/constants';

import { PopupDocument } from '../types';

interface DocumentCheckboxProps {
  newDocument: PopupDocument;
  documentId: string;
  selectedDocuments: PopupDocument[];
  setSelectedDocuments: (documents: PopupDocument[]) => void;
  onlyAllowOneDoc?: boolean;
}

const DocumentCheckbox: React.FC<DocumentCheckboxProps> = ({
  newDocument,
  documentId,
  selectedDocuments,
  setSelectedDocuments,
  onlyAllowOneDoc,
}) => {
  const isSelected = Boolean(
    selectedDocuments.find(
      selectedDocument => selectedDocument.id === documentId,
    ),
  );

  const onChangeCheckbox = () => {
    // Validate DOCUMENT type has valid reference before allowing selection
    const isDocumentType = newDocument.type === Constants.STEP_TYPES.DOCUMENT;
    const referenceId = newDocument.reference.id;
    if (!isSelected && isDocumentType && !referenceId) {
      datadogRum.addError(
        new Error(
          'Cannot select DOCUMENT without valid reference - document filtering may have failed',
          { cause: { newDocument, documentId } },
        ),
      );
      return;
    }

    if (onlyAllowOneDoc && !isSelected) {
      setSelectedDocuments([newDocument]);
      return;
    }

    const newSelectedDocuments = isSelected
      ? selectedDocuments.filter(
          selectedDocument => selectedDocument.id !== documentId,
        )
      : [...selectedDocuments, newDocument];
    setSelectedDocuments(newSelectedDocuments);
  };

  return (
    <div className="flex justify-end">
      <div className="flex h-[60px] items-center justify-between rounded-lg px-2 py-0">
        {isSelected ? (
          <IconSquareRoundedCheckFilled
            data-testid="documentCheckboxSelected"
            onClick={onChangeCheckbox}
            className="text-brand-green! cursor-pointer!"
          />
        ) : (
          <IconSquareRoundedPlus
            data-testid="documentCheckbox"
            onClick={onChangeCheckbox}
            className="text-brand-navy! dark:text-contrast! cursor-pointer!"
          />
        )}
      </div>
    </div>
  );
};

export default DocumentCheckbox;
